const FacebookIcon = ({ color }) => {
  return (
    <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill={color || "currentColor"}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12.0608C22 6.5048 17.5224 2 12 2C6.47758 2 2 6.5048 2 12.0608C2 17.082 5.65634 21.2444 10.4377 22V14.9697H7.8979V12.0608H10.4377V9.84376C10.4377 7.32252 11.9311 5.92892 14.2149 5.92892C15.3089 5.92892 16.4537 6.12558 16.4537 6.12558V8.60155H15.1922C13.9505 8.60155 13.5623 9.37688 13.5623 10.1734V12.0607H16.3355L15.8925 14.9696H13.5623V21.9999C18.3436 21.2457 21.9999 17.0833 21.9999 12.0607L22 12.0608Z"
      />
    </svg>
  )
}

export default FacebookIcon
